<!-- Tirita de gradiente -->
<div class="bandeja-accent"></div>

<div class="bandeja">
    <!-- Barra superior -->
    <header class="bandeja__top">
        <div class="topbar">
            <button class="filtro-btn" (click)="abrirDropdown('sede', $event)"
                [class.filtro-btn--active]="dropdownAbierto === 'sede' || !todasSedesSeleccionadas()"
                title="Filtrar por sede">
                <span>Sede</span>
                <span class="material-icons filtro-btn__caret">expand_more</span>
            </button>

            <button class="filtro-btn" (click)="abrirDropdown('estado', $event)"
                [class.filtro-btn--active]="dropdownAbierto === 'estado' || !todasEstadosSeleccionados()"
                title="Filtrar por estado">
                <span>Estado</span>
                <span class="material-icons filtro-btn__caret">expand_more</span>
            </button>

            <button class="filtro-btn" (click)="abrirDropdown('plan', $event)"
                [class.filtro-btn--active]="dropdownAbierto === 'plan' || selectedPlanes.length > 0"
                title="Filtrar por plan">
                <span>Plan</span>
                <span *ngIf="selectedPlanes.length" class="filtro-btn__count">{{ selectedPlanes.length }}</span>
                <span class="material-icons filtro-btn__caret">expand_more</span>
            </button>

            <app-datepicker label="Desde" [(fecha)]="fechaDesdeStr"></app-datepicker>

            <app-datepicker label="Hasta" [(fecha)]="fechaHastaStr"></app-datepicker>

            <button class="btn-pill btn-pill--primary" (click)="buscarPorFechas()">Buscar por rango</button>
            <button class="btn-pill btn-pill--outline" (click)="exportarSolicitudes()"
                [disabled]="!fechaDesdeStr || !fechaHastaStr || loading">
                <span class="material-icons">file_download</span>
                Exportar a Excel
            </button>

            <button class="filtro-btn" (click)="abrirInfoEstados()"
                title="Información sobre Estados" aria-label="Información sobre Estados">
                <span class="material-icons">help_outline</span>
            </button>

            <span class="topbar__spacer"></span>

            <div class="contadores">
                <span class="stat stat--total"><strong>{{ cantidadSolicitudesTotal }}</strong> total</span>
                <span class="stat stat--pend"><strong>{{ cantidadSolicitudesPendientes }}</strong> sin leer</span>
                <span class="stat stat--leida"><strong>{{ cantidadSolicitudesLeidas }}</strong> leídas</span>
            </div>

            <div class="buscador">
                <input
                    type="text"
                    [(ngModel)]="textoFiltro"
                    (keyup.enter)="buscarTexto()"
                    placeholder="Buscar solicitud..." />
                <button
                    type="button"
                    class="buscador__clear"
                    *ngIf="textoFiltro"
                    (click)="limpiarBusqueda()"
                    title="Limpiar búsqueda"
                    aria-label="Limpiar búsqueda">
                    <span class="material-icons">close</span>
                </button>
                <button
                    type="button"
                    class="buscador__btn"
                    (click)="buscarTexto()"
                    title="Buscar">
                    <span class="material-icons">search</span>
                    <span>Buscar</span>
                </button>
            </div>
        </div>

        <div class="hint-busqueda" *ngIf="textoFiltro && idActividadSeleccionada !== TODOS_ID">
            <span class="material-icons">info</span>
            <span>Para obtener mejores resultados, le recomendamos buscar en «Todos».</span>
        </div>
    </header>

    <!-- Cuerpo: trámites + solicitudes -->
    <div class="bandeja__body">
        <!-- Izquierda: lista de trámites -->
        <aside class="tramites">
            <div class="tramites__titulo">
                <span class="material-icons">apps</span>
                Trámites
            </div>
            <div class="tramites__lista">
                <ng-container *ngIf="flagCargandoTramites; else tramitesListos">
                    <div class="tramite tramite--skeleton" *ngFor="let i of skeletonRows">
                        <span class="skeleton-bar skeleton-bar--tramite"></span>
                        <span class="skeleton-bar skeleton-bar--tramite-badge"></span>
                    </div>
                </ng-container>

                <ng-template #tramitesListos>
                    <button class="tramite tramite--todos"
                        [class.tramite--active]="idActividadSeleccionada === TODOS_ID"
                        (click)="seleccionarTodos()">
                        <span class="tramite__nombre">Todos</span>
                        <span class="tramite__badges">
                            <span class="badge badge--pend"
                                [title]="labelPendientes(getTotalPendientes())">
                                {{ getTotalPendientes() }}
                            </span>
                            <span class="badge badge--leida"
                                [title]="labelLeidas(getTotalLeidas())">
                                {{ getTotalLeidas() }}
                            </span>
                        </span>
                    </button>

                    <button *ngFor="let actividad of actividades" class="tramite"
                        [class.tramite--active]="actividad._id === idActividadSeleccionada"
                        (click)="seleccionarActividad(actividad)">
                        <span class="tramite__nombre">{{ actividad.nombre }}</span>
                        <span class="tramite__badges">
                            <span class="badge badge--pend"
                                [title]="labelPendientes(getCountPendientes(actividad))">
                                {{ getCountPendientes(actividad) }}
                            </span>
                            <span class="badge badge--leida" [title]="labelLeidas(getCountLeidas(actividad))">
                                {{ getCountLeidas(actividad) }}
                            </span>
                        </span>
                    </button>

                    <div *ngIf="actividades.length === 0" class="tramites__vacio">
                        Sin trámites disponibles
                    </div>
                </ng-template>
            </div>
        </aside>

        <!-- Derecha: tabla de solicitudes -->
        <section class="solicitudes">
            <div class="tabla-wrap">
                <table class="tabla">
                    <colgroup>
                        <col class="col-num" />
                        <col class="col-beneficiario" />
                        <col class="col-contacto" />
                        <col class="col-sede" />
                        <col class="col-tramite" />
                        <col class="col-plan" />
                        <col class="col-fecha" />
                        <col class="col-dif" />
                        <col class="col-estado" />
                        <col class="col-acciones" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="th-num">Nro.</th>
                            <th>Beneficiario</th>
                            <th>Titular</th>
                            <th>Sede</th>
                            <th>Trámite</th>
                            <th class="th-plan"
                                [attr.aria-sort]="sortBy === 'plan' ? (ordenPlan === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="th-sort" (click)="toggleOrdenPlan()"
                                    title="Ordenar por plan">
                                    Plan
                                    <span class="material-icons th-sort__icon">
                                        {{ sortBy === 'plan' ? (ordenPlan === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                                    </span>
                                </button>
                            </th>
                            <th class="th-fecha"
                                [attr.aria-sort]="sortBy === 'fecha' ? (ordenFecha === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="th-sort" (click)="toggleOrdenFecha()"
                                    title="Ordenar por fecha">
                                    Fecha
                                    <span class="material-icons th-sort__icon">
                                        {{ sortBy === 'fecha' ? (ordenFecha === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                                    </span>
                                </button>
                            </th>
                            <!-- DIFERENCIAL -->
                            <th class="th-dif"
                                [attr.aria-sort]="sortBy === 'dif' ? (ordenDif === 'asc' ? 'ascending' : 'descending') : 'none'">
                                <button type="button" class="th-sort" (click)="toggleOrdenDif()"
                                    title="Ordenar por diferencial (aprobadas / anuladas)">
                                    Dif.
                                    <span class="material-icons th-sort__icon">
                                        {{ sortBy === 'dif' ? (ordenDif === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                                    </span>
                                </button>
                            </th>
                            <th class="th-estado">Estado</th>
                            <th class="th-acciones"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!flagLoaded; else tablaContenido">
                            <tr class="skeleton-row" *ngFor="let i of skeletonRows">
                                <td colspan="10">
                                    <div class="skeleton">
                                        <span class="skeleton-bar skeleton-bar--contacto"></span>
                                        <span class="skeleton-bar skeleton-bar--sm"></span>
                                        <span class="skeleton-bar skeleton-bar--md"></span>
                                        <span class="skeleton-bar skeleton-bar--sm"></span>
                                        <span class="skeleton-bar skeleton-bar--md"></span>
                                        <span class="skeleton-bar skeleton-bar--sm"></span>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #tablaContenido>
                        <tr *ngFor="let element of solicitudesPaginadas; trackBy: trackBySolicitud"
                            [class.row--unread]="!element.leido">
                            <td class="td-num">{{ element._nro }}</td>
                            <td class="td-contacto">
                                <div class="contacto">
                                    <span class="contacto__principal">{{ element.beneficiario | nombreExiste }}</span>
                                    <span class="contacto__sec">{{ element.beneficiario_parentesco }}</span>
                                </div>
                            </td>
                            <td class="td-contacto">
                                <div class="contacto">
                                    <span class="contacto__principal">{{ element.solicitante | nombreExiste }}</span>
                                    <span class="contacto__sec">DNI {{ element.usuario_identificacion | nombreExiste }}</span>
                                </div>
                            </td>
                            <td class="td-truncate">
                                <span class="truncate-text" (mouseenter)="mostrarTooltip($event, element.signoSedeNombre)"
                                    (mouseleave)="ocultarTooltip()">{{ element.signoSedeNombre }}</span>
                            </td>
                            <td class="td-truncate">
                                <span class="truncate-text" (mouseenter)="mostrarTooltip($event, element.actividad_nombre)"
                                    (mouseleave)="ocultarTooltip()">{{ element.actividad_nombre }}</span>
                            </td>
                            <td class="td-plan">
                                <span class="plan-chip" [class.plan-chip--vacio]="!element.plan">{{ element.plan || 'Sin plan' }}</span>
                            </td>
                            <td class="td-fecha">{{ element.createdAt | date:"dd/MM/yy" }}</td>
                            <td class="td-dif">
                                <ng-container *ngIf="element.dif; else sinDif">
                                    <span class="dif-chip dif-chip--ok">+{{ element.dif.aprobadas }}</span>
                                    <span class="dif-chip dif-chip--no">-{{ element.dif.anuladas }}</span>
                                </ng-container>
                                <ng-template #sinDif><span class="dif-chip dif-chip--vacio" title="Sin historial contado">—</span></ng-template>
                            </td>
                            <td class="td-estado">
                                <span class="estado-chip" [ngClass]="getEstadoChipClase(element.lastState_numberState)">
                                    {{ getStateName(element.lastState_numberState) }}
                                </span>
                            </td>
                            <td class="td-acciones">
                                <div class="acciones-row">
                                    <button class="kebab" (click)="verSolicitud(element)" title="Ver solicitud"
                                        aria-label="Ver solicitud">
                                        <span class="material-icons">remove_red_eye</span>
                                    </button>
                                    <button class="kebab" (click)="toggleMenu($event, element)" aria-label="Acciones">
                                        <span class="material-icons">more_vert</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="solicitudesPaginadas.length === 0" class="tabla-vacia">
                            <td colspan="10">No hay datos que coincidan con el filtro</td>
                        </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>

            <!-- Paginación -->
            <footer class="paginacion">
                <div class="paginacion__size">
                    <select [ngModel]="pageSize" (ngModelChange)="cambiarPageSize($event)">
                        <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
                    </select>
                    <span>por página</span>
                </div>
                <span class="paginacion__info">
                    <span *ngIf="!flagLoaded" class="cargando">Cargando solicitudes...</span>
                    <span *ngIf="flagLoaded">{{ totalResultados }} resultados</span>
                </span>
                <div class="paginacion__nav">
                    <button class="paginacion__btn" (click)="cambiarPagina(paginaActual - 1)"
                        [disabled]="paginaActual <= 1" aria-label="Anterior">‹</button>
                    <span class="paginacion__pag">{{ paginaActual }} / {{ totalPaginas }}</span>
                    <button class="paginacion__btn" (click)="cambiarPagina(paginaActual + 1)"
                        [disabled]="paginaActual >= totalPaginas" aria-label="Siguiente">›</button>
                </div>
            </footer>
        </section>
    </div>
</div>

<!-- Dropdowns de filtros (Sede / Estado / Plan) -->
<div class="backdrop" *ngIf="dropdownAbierto" (click)="cerrarDropdown()"></div>

<div class="dropdown-panel" *ngIf="dropdownAbierto === 'sede'"
    [style.top.px]="dropdownPos.top" [style.left.px]="dropdownPos.left">
    <div class="dropdown-panel__head">
        <span class="dropdown-panel__title">Sedes</span>
        <button class="dropdown-panel__toggle" (click)="toggleTodoSedes()">
            {{ todasSedesSeleccionadas() ? 'Quitar todo' : 'Seleccionar todo' }}
        </button>
    </div>
    <div class="dropdown-panel__list">
        <button *ngFor="let sede of sedesByUsuario" class="opt"
            [class.opt--on]="selectSede.includes(sede._id)"
            (click)="toggleSede(sede._id)">
            <span class="material-icons opt__check">{{ selectSede.includes(sede._id) ? 'check_box' : 'check_box_outline_blank' }}</span>
            <span class="opt__label">{{ sede.nombre }}</span>
        </button>
    </div>
</div>

<div class="dropdown-panel" *ngIf="dropdownAbierto === 'estado'"
    [style.top.px]="dropdownPos.top" [style.left.px]="dropdownPos.left">
    <div class="dropdown-panel__head">
        <span class="dropdown-panel__title">Estados</span>
        <button class="dropdown-panel__toggle" (click)="toggleTodoEstados()">
            {{ todasEstadosSeleccionados() ? 'Quitar todo' : 'Seleccionar todo' }}
        </button>
    </div>
    <div class="dropdown-panel__list">
        <button *ngFor="let estado of estadosChips" class="opt"
            [class.opt--on]="selectedEstados.includes(estado.number)"
            (click)="toggleEstado(estado.number)">
            <span class="material-icons opt__check">{{ selectedEstados.includes(estado.number) ? 'check_box' : 'check_box_outline_blank' }}</span>
            <span class="opt__label">{{ getStateName(estado.number) }}</span>
        </button>
    </div>
</div>

<div class="dropdown-panel" *ngIf="dropdownAbierto === 'plan'"
    [style.top.px]="dropdownPos.top" [style.left.px]="dropdownPos.left">
    <div class="dropdown-panel__head">
        <span class="dropdown-panel__title">Planes</span>
        <button class="dropdown-panel__toggle" *ngIf="selectedPlanes.length"
            (click)="limpiarPlanes()">
            Ver todos
        </button>
    </div>
    <div class="dropdown-panel__list">
        <button *ngFor="let plan of planes" class="opt"
            [class.opt--on]="planSeleccionado(idPlan(plan))"
            (click)="togglePlan(idPlan(plan))">
            <span class="material-icons opt__check">{{ planSeleccionado(idPlan(plan)) ? 'check_box' : 'check_box_outline_blank' }}</span>
            <span class="opt__label">{{ plan.denominacion }}</span>
        </button>
        <div *ngIf="!planes.length" class="dropdown-panel__empty">Sin planes cargados</div>
    </div>
</div>

<!-- Menú kebab flotante -->
<div class="backdrop" *ngIf="menuSolicitud" (click)="cerrarMenu()"></div>
<div class="kebab-menu" *ngIf="menuSolicitud" [style.top.px]="menuPos.top" [style.right.px]="menuPos.right">
    <button class="kebab-menu__item" (click)="accionVerSolicitud()">
        <span class="material-icons">remove_red_eye</span>
        <span>Ver solicitud</span>
    </button>
    <button class="kebab-menu__item" (click)="accionHistorialDif()">
        <span class="material-icons">insights</span>
        <span>Historial del diff</span>
    </button>
    <button class="kebab-menu__item" (click)="accionDetalleGecros()">
        <span class="material-icons">badge</span>
        <span>Detalle GECROS</span>
    </button>
    <button class="kebab-menu__item" (click)="accionDetalleSede()">
        <span class="material-icons">home</span>
        <span>Detalle sede</span>
    </button>
</div>

<!-- Tooltip custom -->
<div class="tooltip" [class.tooltip--visible]="tooltipVisible" [style.top.px]="tooltipPos.top" [style.left.px]="tooltipPos.left">
    {{ tooltipTexto }}
</div>

<!-- Loading overlay -->
<div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
</div>

<!-- Contenido proyectado del popup "Información sobre Estados" -->
<ng-template #infoEstadosTpl>
    <app-stepper [pasosCustom]="pasosInfoEstados" [stepperSet]="4" [vertical]="true"
        [sinProgreso]="true"></app-stepper>
</ng-template>
